/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from '../runtime.js';
import { DgContentsFromJSON, DgContentsToJSON, } from './DgContents.js';
import { DgItineraryFromJSON, DgItineraryToJSON, } from './DgItinerary.js';
import { DgRequestTypeFromJSON, DgRequestTypeToJSON, } from './DgRequestType.js';
import { DgTaxFromJSON, DgTaxToJSON, } from './DgTax.js';
/**
 * Check if a given object implements the DgOffer interface.
 */
export function instanceOfDgOffer(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "premium" in value;
    isInstance = isInstance && "coverage" in value;
    isInstance = isInstance && "coveragePercentage" in value;
    isInstance = isInstance && "serviceCap" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "taxesTotal" in value;
    isInstance = isInstance && "requestType" in value;
    isInstance = isInstance && "maxHoursBeforeDeparture" in value;
    isInstance = isInstance && "minMinutesDelay" in value;
    isInstance = isInstance && "contractExpiryDateTime" in value;
    isInstance = isInstance && "createdDateTime" in value;
    isInstance = isInstance && "itinerary" in value;
    isInstance = isInstance && "extAttributes" in value;
    isInstance = isInstance && "contents" in value;
    return isInstance;
}
export function DgOfferFromJSON(json) {
    return DgOfferFromJSONTyped(json, false);
}
export function DgOfferFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'premium': json['premium'],
        'coverage': json['coverage'],
        'coveragePercentage': json['coverage_percentage'],
        'serviceCap': json['service_cap'],
        'currency': json['currency'],
        'taxesTotal': json['taxes_total'],
        'taxes': !exists(json, 'taxes') ? undefined : (json['taxes'].map(DgTaxFromJSON)),
        'requestType': DgRequestTypeFromJSON(json['request_type']),
        'maxHoursBeforeDeparture': json['max_hours_before_departure'],
        'minMinutesDelay': json['min_minutes_delay'],
        'contractExpiryDateTime': (new Date(json['contract_expiry_date_time'])),
        'createdDateTime': (new Date(json['created_date_time'])),
        'itinerary': DgItineraryFromJSON(json['itinerary']),
        'extAttributes': json['ext_attributes'],
        'contents': (mapValues(json['contents'], DgContentsFromJSON)),
    };
}
export function DgOfferToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'premium': value.premium,
        'coverage': value.coverage,
        'coverage_percentage': value.coveragePercentage,
        'service_cap': value.serviceCap,
        'currency': value.currency,
        'taxes_total': value.taxesTotal,
        'taxes': value.taxes === undefined ? undefined : (value.taxes.map(DgTaxToJSON)),
        'request_type': DgRequestTypeToJSON(value.requestType),
        'max_hours_before_departure': value.maxHoursBeforeDeparture,
        'min_minutes_delay': value.minMinutesDelay,
        'contract_expiry_date_time': (value.contractExpiryDateTime.toISOString()),
        'created_date_time': (value.createdDateTime.toISOString()),
        'itinerary': DgItineraryToJSON(value.itinerary),
        'ext_attributes': value.extAttributes,
        'contents': (mapValues(value.contents, DgContentsToJSON)),
    };
}
